export default "/fonts/vendor/@fontsource/space-mono/files/space-mono-latin-700-normal.woff2?1a051f5297fae3eae3ba78e59622c2e2";